import { IProductData, IProduct, IProductDataInput } from "./product.type";
import * as format from "@/utils/formatQuantity"
import { OnlineStore } from "../onlineStore/onlineStore";
import { PreOrder } from "../preorder/preorder";

export class Product implements IProduct {
    cprcode: number;
    iprcode: number;
    psqty?: number;
    prCountryEn?: string;
    onlineCategoryL1En: string;
    onlineCategoryL2En: string;
    onlineCategoryL3En: string;
    hemaBrandEn?: string;
    hemaSizedesc?: string;
    hemaNameEn?: string;
    hemaNameTh?: string;
    prUseOriginalImg?: string;
    maxQtyInCart?: number;
    availableStore: Map<number, OnlineStore>;
    badgeLeft?: string;
    avail_store?: Array<any>;
    twofor?: number;
    storeOnly?: boolean;
    preOrder?: PreOrder

    constructor(data: IProductDataInput) {
        this.cprcode = data.cprcode
        this.iprcode = data.iprcode
        this.psqty = data.psqty
        this.prCountryEn = data.pr_country_en
        this.onlineCategoryL1En = data.online_category_l1_en
        this.onlineCategoryL2En = data.online_category_l2_en
        this.onlineCategoryL3En = data.online_category_l3_en
        this.hemaBrandEn = data.hema_brand_en
        this.hemaSizedesc = data.hema_sizedesc
        this.hemaNameEn = data.hema_name_en
        this.hemaNameTh = data.hema_name_th
        this.prUseOriginalImg = data.pr_use_original_img
        this.availableStore = new Map()
        if (data.avail_store) {
            for (const [brcode, visi] of Object.entries(data.avail_store)) {
                if (brcode) {
                    if (visi) {
                        this.addStore(new OnlineStore({ brcode: parseInt(brcode), visibility: visi.visibility }))
                    }
                }
            }
        }
        this.storeOnly = false;
        // this.maxQtyInCart = data.maxQtyInCart
    }

    isValidAtBranch(branchCode: number): boolean {
        if (this.availableStore?.get(branchCode) !== null) {
            if (this.availableStore?.get(branchCode)?.visibility) {
                if (this.availableStore?.get(branchCode)?.price !== null &&
                    this.availableStore?.get(branchCode)?.inventory !== null) {
                    if (this.availableStore?.get(branchCode)?.price?.lastPrice !== null &&
                        this.availableStore?.get(branchCode)?.inventory?.stock !== null) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    stockAt(branchCode: number): number {
        if (this.availableStore?.get(branchCode) != null) {
            if (this.availableStore?.get(branchCode)?.visibility) {
                if (this.availableStore?.get(branchCode)?.price != null &&
                    this.availableStore?.get(branchCode)?.inventory != null) {
                    if (this.availableStore?.get(branchCode)?.price?.lastPrice !== null &&
                        this.availableStore?.get(branchCode)?.inventory?.stock !== null) {
                        return (this.availableStore?.get(branchCode)?.inventory?.stock) as number;
                    }
                }
            }
        }
        return -1;
    }
    priceAt(branchCode: number): number | undefined {
        if (this.availableStore?.get(branchCode) != null) {
            if (this.availableStore?.get(branchCode)?.visibility) {
                if (this.availableStore?.get(branchCode)?.price != null) {
                    if (this.availableStore?.get(branchCode)?.price?.price != null) {
                        return this.availableStore?.get(branchCode)?.price?.price;
                    }
                }
            }
        }
    }
    originalPriceAt(branchCode: number): number | undefined {
        if (this.availableStore?.get(branchCode) != null) {
            if (this.availableStore?.get(branchCode)?.visibility) {
                if (this.availableStore?.get(branchCode)?.price != null) {
                    if (this.availableStore?.get(branchCode)?.price?.price != null) {
                        return this.availableStore?.get(branchCode)?.price?.lastPrice;
                    }
                }
            }
        }
    }
    formattedPriceAt(branchCode: number): string | undefined {
        const price = this.priceAt(branchCode)
        if (price) {
            return format.formatQuantity(price);
        }
    }
    formattedOriginalPriceAt(branchCode: number): string | undefined {
        const price = this.priceAt(branchCode);
        const originalPrice = this.originalPriceAt(branchCode);
        if (originalPrice) {
            if (price !== originalPrice) {
                return format.formatQuantity(originalPrice);
            }
        }
    }
    discountPercentAt(branchCode: number): string | undefined {
        const price = this.priceAt(branchCode);
        const originalPrice = this.originalPriceAt(branchCode);
        if (price) {
            if (originalPrice) {
                if (price !== originalPrice) {
                    return format.formatPercent((originalPrice - price) / originalPrice * 100);
                }
            }
        }
    }
    isOutOfStockAt(branchCode: number): boolean {
        return this.stockAt(branchCode) <= 0;
    }
    addStore(store: OnlineStore): void {
        if (store.brcode != null) {
            this.availableStore.set(store.brcode, store);
        }
    }
    data(): IProductData {
        return Object.assign({}, this);
    }

    isAvailableAt(branchCode: number): boolean {
        if (this.availableStore.get(branchCode) == null) {
            return false;
        }
        return true;
    }
}



